/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

const ListItemWrapper = ({ children, noSidePadding, rightBorderColor, bgColor }) => {
  const style = css`
    padding: 0.8rem ${!noSidePadding ? '1rem' : '0'};
    border-bottom: solid 1px ${bgColor || COLORS.light2};
    background-color: ${bgColor};
    ${rightBorderColor ? `border-right: solid .5rem ${rightBorderColor};` : ''}

    &:hover {
      background-color: ${COLORS.light1};
    }
  `

  return <div css={style}>{children}</div>
}

export default ListItemWrapper
